module.exports = __webpack_public_path__ + "img/pin-diamond.5a922187.png";